import React from "react";
import { ArrowUpRight } from "lucide-react";
import { STATUS } from "@/status";

export default function StatusBar({ className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center gap-x-0 gap-y-1 overflow-x-auto ${className}`}
      style={{ scrollbarWidth: "none" }}
      data-testid="status-bar"
    >
      {/* Prefix */}
      <span className="font-mono text-[10px] tracking-[0.22em] uppercase mr-2.5 shrink-0 text-mute">
        {STATUS.prefix}:
      </span>

      {STATUS.items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && (
            <span
              className="mx-2.5 font-mono text-[10px] shrink-0 hidden sm:inline text-mute opacity-60"
              aria-hidden
            >
              ·
            </span>
          )}

          {item.href ? (
            <a
              href={item.href}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 font-mono text-[10px] tracking-[0.12em] shrink-0 text-mute hover:opacity-70 transition-opacity group"
            >
              {item.label}
              {item.value && (
                <>
                  :{" "}
                  <span className="font-medium ml-0.5 text-ink-soft">{item.value}</span>
                </>
              )}
              <ArrowUpRight
                size={9}
                strokeWidth={2.5}
                className="opacity-0 group-hover:opacity-60 transition-opacity ml-0.5"
              />
            </a>
          ) : (
            <span className="font-mono text-[10px] tracking-[0.12em] shrink-0 text-mute">
              {item.value ? (
                <>
                  {item.label}:{" "}
                  <span className="font-medium text-ink-soft">{item.value}</span>
                </>
              ) : (
                item.label
              )}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
